// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1znli","title":"styles_title__Ttq9o"};